import { AnyAction } from 'redux';
import {
	SET_SELECTED_DOCUMENT_TABLE,
	SET_SELECTED_SUBDOCUMENT_TABLE
} from '../types/types';

const initialState = {
	selectedDocumentTable: 'Users',
	selectedSubDocumentTable: 'All'
};

export default function tablesQuickAccessReducer(
	state = initialState,
	action: AnyAction
) {
	switch (action.type) {
		case SET_SELECTED_DOCUMENT_TABLE:
			return {
				selectedDocumentTable: action.selectedDocumentTable,
				selectedSubDocumentTable: action.selectedSubDocumentTable
			};
		case SET_SELECTED_SUBDOCUMENT_TABLE:
			return {
				...state,
				selectedSubDocumentTable: action.selectedSubDocumentTable
			};
		default:
			return state;
	}
}
